import {
  MenuCategoriesGridCategory,
  MenuCategoriesGridCategoryHeading,
  MenuCategoriesGridCategoryRow,
  MenuCategoriesGridContainer,
  MenuCategoriesGridCustomProductCard,
  MenuCategoriesGridDenseProductsRow,
  MenuCategoriesGridNav,
  MenuCategoriesGridNavItem,
  MenuCategoriesGridProductCardLink,
  MenuCategoriesGridProductCardPressable,
  MenuCategoriesGridProductsStack,
} from './components';

export const MenuCategoriesGrid = {
  Nav: MenuCategoriesGridNav,
  NavItem: MenuCategoriesGridNavItem,
  Container: MenuCategoriesGridContainer,
  Category: MenuCategoriesGridCategory,
  CategoryHeading: MenuCategoriesGridCategoryHeading,
  CategoryRow: MenuCategoriesGridCategoryRow,
  ProductsStack: MenuCategoriesGridProductsStack,
  DenseProductsRow: MenuCategoriesGridDenseProductsRow,
  ProductCardLink: MenuCategoriesGridProductCardLink,
  ProductCardPressable: MenuCategoriesGridProductCardPressable,
  CustomProductCard: MenuCategoriesGridCustomProductCard,
};
